<template>
  <PageHeader
      title="Field Survey"
      back
      @back="toCustomer"
  >
    <Stepper
        :tabs="tabs"
        :captions="captions"
        :complete="complete"
        @position="stepChange($event)"
        ref="stepper"
        v-if="!!customer"
        vertical
    >

      <template v-slot:CorridorAwarenessDetails>
        <CorridorAwarenessDetails
            ref="fieldCorridorAwarenessStep"
            v-model="fieldCorridorAwarenessFormFields"
            :fieldSurveyAssessment="fieldSurveyAssessment"
            :existingField="field"
            @next="nextStep"
        >
        </CorridorAwarenessDetails>

      </template>


      <template v-slot:VisibleMitigation>
        <VisibleMitigation
            ref="visibleMitigationStep"
            :field="field"
            v-model="visibleMitigationFormFields"
        >

          <div class="text-left mt-3">
            <v-btn color="primary" @click="saveVisibleMitigation" :disabled="!isVisibleMitigationFormFieldsValid" class="mr-2">Save</v-btn>
            <v-btn color="primary" @click="saveVisibleMitigationAndGoToMapField" :disabled="!isVisibleMitigationFormFieldsValid" outlined>
              {{ isFieldMapped ? 'Save and remap field' : 'Save and map field' }}
            </v-btn>
          </div>
        </VisibleMitigation>

      </template>


    </Stepper>
    <v-row v-if="showGoToFieldMap" class="mx-4 my-4">
      <v-btn color="primary" class="mr-3 mb-2 d-xs-block" @click="saveAndDone">Submit</v-btn>
      <v-btn  color="gray darken-3" class="mb-2" @click="toFieldMapping">Go to map field</v-btn>
    </v-row>
  </PageHeader>
</template>

<script>
import Stepper from "@/components/Stepper";
import FieldSurvey from "@/views/partners/eco_bw/views/fieldSurvey/FieldSurvey";
import LandSizeInput from "@/components/LandSizeInput";
import Row from "@/components/Row";
import LocationInput from "@/components/LocationInput";
import CorridorAwarenessDetails from "@/views/partners/eco_bw/views/fieldSurvey/CorridorAwarenessDetails";
import VisibleMitigation from "@/views/partners/eco_bw/views/fieldSurvey/VisibleMitigation";
import TextInput from "@/components/TextInput";
import {checkVisibleMitigationValid, WalkFieldType} from "@/views/partners/eco_bw/views/fieldSurvey/field-survey";
import SelectInput from "@/components/SelectInput";
import NewFieldForm from "@/views/partners/eco_bw/views/fieldSurvey/NewFieldForm";
import {createEmptyFieldSurveyAssessment} from "@/views/partners/eco_bw/utils";
import fields from "@/mixins/fields";
import PageHeader from "@/components/PageHeader";
import { v4 as uuidv4 } from 'uuid';

export default {
  components: {
    Stepper,
    FieldSurvey,
    LocationInput,
    SelectInput,
    Row,
    LandSizeInput,
    CorridorAwarenessDetails,
    VisibleMitigation,
    TextInput,
    NewFieldForm,
    PageHeader
  },
  data() {
    return {
      showGoToFieldMap: false,
      fieldSurveyAssessment: {
        fieldCorridorAwarenessFormFields: null,
        visibleMitigationFormFields: null,
        fieldUuid: null,
        uuid: null,
        assessmentName: 'Field Survey'
      },
      walkFieldType:WalkFieldType,
      tabs: [
        'CorridorAwarenessDetails',
        'VisibleMitigation',
      ],
      captions: {
        'VisibleMitigation': 'Visible Mitigation',
        'CorridorAwarenessDetails': 'Field Details',
      },
      fieldSurveyFormField: {
        location: null,
        cropId: null,
        fieldSize: null,
        fieldType: null,
      },
      conservationAgricultureFormFields: null,
      visibleMitigationFormFields: null,
      fieldCorridorAwarenessFormFields: {
        fieldRegistrationDate: null,
        evidenceFieldExpansionOntoElephantCorridor: false,
        areCorridorsHelping: null,
        peopleSupportedByField: {
          label: 'People supported by field',
          answer: null
        },
        ownership: {
          label: 'Ownership',
          answer: null
        }
      },
    }
  },
  mounted() {
    // if field exist update form data, if no field dont do anything
    if (!this.customer.fields) {
      this.customer.fields = []
    }
    if (this.fieldSurveyAssessment) {
      this.fieldSurveyAssessment.fieldUuid = this.fieldUuid;
      // DO NOT overwrite the assessment's UUID - it should keep its own UUID!
      // this.fieldSurveyAssessment.uuid = this.fieldUuid;  // <-- REMOVED: This was corrupting data
     }
    if (this.fieldAssessment) {
      this.fieldCorridorAwarenessFormFields = this.fieldAssessment.fieldCorridorAwarenessFormFields;
      this.conservationAgricultureFormFields = this.fieldAssessment.conservationAgricultureFormFields;
      this.visibleMitigationFormFields = this.fieldAssessment.visibleMitigationFormFields;
      // Preserve the assessment UUID when editing
      this.fieldSurveyAssessment.uuid = this.fieldAssessment.uuid;
      this.fieldSurveyAssessment.created_at = this.fieldAssessment.created_at;
    }

    if (this.fieldSurveyAssessment && this.fieldSurveyAssessment.fieldCorridorAwarenessFormFields) {
      this.fieldCorridorAwarenessFormFields = this.fieldSurveyAssessment.fieldCorridorAwarenessFormFields;
    }
    if (this.fieldSurveyAssessment && this.fieldSurveyAssessment.conservationAgricultureFormFields) {
      this.conservationAgricultureFormFields = this.fieldSurveyAssessment.conservationAgricultureFormFields;
    }
    if (this.fieldSurveyAssessment && this.fieldSurveyAssessment.visibleMitigationFormFields) {
      this.visibleMitigationFormFields = this.fieldSurveyAssessment.visibleMitigationFormFields;
    }
  },

  computed: {
    customerUuid() { return this.$route.query.uuid; },
    assessmentUuid() { return this.$route.query.assessmentUuid; },
    customer() { return this.$store.getters.customer(this.$route.query.uuid); },
    complete() { return [] },
    outerFields() {
      return this.customer.fields ? this.customer.fields.filter(f => f.fieldType === 'outer field') : [];
    },
    crops() { return this.$store.getters.crops; },
    fieldUuid() { 
      // When creating new with specific field: use farmUuid from query
      if (this.$route.query.farmUuid) {
        return this.$route.query.farmUuid;
      }
      // When editing existing assessment: get fieldUuid from the assessment
      if (this.assessmentUuid) {
        const assessment = this.$store.getters.assessments.find(
          obj => obj.uuid === this.assessmentUuid && obj.customerUuid === this.customerUuid
        );
        if (assessment && assessment.fieldUuid) {
          return assessment.fieldUuid;
        }
      }
      // When creating new without specific field: get the most recent field from customer object
      const customerFields = (this.customer && this.customer.fields) ? this.customer.fields : [];
      if (customerFields.length > 0) {
        return customerFields[customerFields.length - 1].uuid;
      }
      return null;
    },
    field() {
      const customerFields = this.$store.getters.fieldsForCustomers(this.customerUuid);
      let foundField = customerFields ? customerFields.find( f => f.uuid===this.fieldUuid ) : null;

      // Fallback: if we can't find the field by UUID, try to match by field properties from the assessment
      if (!foundField && this.fieldAssessment && this.fieldAssessment.fieldCorridorAwarenessFormFields && customerFields.length > 0) {
        const assessmentData = this.fieldAssessment.fieldCorridorAwarenessFormFields;
        
        // Try to find field by matching registration date and ownership
        foundField = customerFields.find(f => 
          f.registrationDate === assessmentData.fieldRegistrationDate &&
          f.ownership === assessmentData.ownership?.answer
        );
      }
      
      return foundField;
    },
    isConservationAgricultureFormFieldsValid() {
      let x = false
      if (this.conservationAgricultureFormFields) {
        x = Object.values(this.conservationAgricultureFormFields).filter(formField => {
              return formField.hasOwnProperty("fieldType") && formField.fieldType !== null && formField.fieldType !== undefined && !formField.answer;
            });
        x = x.filter(item => ![true, false].includes(item.answer)).filter(item => ![true, false].includes(item.answer)).length === 0
      };
      return x
    },
    isVisibleMitigationFormFieldsValid() {
      return checkVisibleMitigationValid(this.visibleMitigationFormFields);
    },
    fieldAssessment(){
      const assessments = this.$store.getters.assessments.filter((obj) => obj.uuid === this.assessmentUuid && obj.customerUuid === this.customerUuid);
      return assessments.length > 0 ? assessments[0] : null;
    },
    isFieldMapped() {
      return this.field && this.field.polygon && this.field.polygon.length > 0;
    }
  },
  methods: {
    stepChange(to) {
      this.firstStep = (to==='first');
      this.lastStep = (to==='last');
    },
    nextStep() {
      this.$refs.stepper.nextStep();
    },
    saveFieldSection() {
      this.fieldSurveyAssessment = createEmptyFieldSurveyAssessment(this.customerUuid, this.fieldUuid);
      this.nextStep();
    },
    saveVisibleMitigationAndGoToMapField() {
      this.saveAndDone()
      this.toFieldMapping();
    },
    saveVisibleMitigation() {
      this.saveAndDone()
      this.toCustomer();
    },
    saveFieldCorridorAwareness() {
      this.fieldSurveyAssessment.fieldCorridorAwarenessFormFields = this.fieldCorridorAwarenessFormFields
      this.nextStep();
    },

    saveConservationAgriculture() {
      this.$refs.conservationAgricultureStep.validate()
      if (this.conservationAgricultureFormFields) {
        if (this.conservationAgricultureFormFields.fieldType) {
          this.fieldSurveyFormField.fieldType = this.conservationAgricultureFormFields.fieldType
          this.$store.dispatch('upsertField', this.fieldSurveyFormField);
        }
        this.fieldSurveyAssessment.conservationAgricultureFormFields = this.conservationAgricultureFormFields
      }

      this.nextStep();
    },
    saveAndDone() {
      // IMPORTANT: Create a copy to avoid mutating the store object directly
      const baseAssessment = this.fieldAssessment ? { ...this.fieldAssessment } : this.fieldSurveyAssessment;
      this.fieldSurveyAssessment = baseAssessment;
      
      this.fieldSurveyAssessment.customerUuid = this.customerUuid
      this.fieldSurveyAssessment.assessmentType = 'FieldSurvey'
      this.fieldSurveyAssessment.visibleMitigationFormFields = this.visibleMitigationFormFields
      this.fieldSurveyAssessment.created_at ||= new Date().toISOString()
      
      // If UUID is null/undefined, we need to generate one AND remove the old null-UUID assessment
      const oldUuid = this.fieldSurveyAssessment.uuid;
      this.fieldSurveyAssessment.uuid ||= uuidv4();  // Generate UUID if doesn't exist
      
      // If we generated a new UUID, remove the old assessment with null UUID
      if (!oldUuid && !this.assessmentUuid) {
        // Remove old assessment with null UUID to prevent duplicates
        const nullUuidIndex = this.$store.state.assessments.findIndex(a => 
          !a.uuid && 
          a.customerUuid === this.customerUuid && 
          a.assessmentType === 'FieldSurvey'
        );
        if (nullUuidIndex >= 0) {
          this.$store.state.assessments.splice(nullUuidIndex, 1);
        }
      }
      
      this.fieldSurveyAssessment.fieldUuid ||= this.field?.uuid;  // Link to the actual field
      
      this.$store.commit('upsertAssessment', this.fieldSurveyAssessment)
    },
    toCustomer() { this.$router.push({ name: 'ShowCustomer', query: { uuid: this.customerUuid } }); },
    toFieldMapping() {
      // Use this.field?.uuid as primary source since it's the resolved field object
      // Fallback to this.fieldUuid for cases where field hasn't been resolved yet
      const fieldId = this.field?.uuid || this.fieldUuid;
      this.$router.push({ name: 'FieldMap', query: { uuid: this.customerUuid, fieldUuid: fieldId, isFarm: false } });
    },
  },
  mixins: [fields],
}
</script>

<style scoped>
</style>


